import React, { useState } from 'react';
import styles from './styles.module.css';
import { FSF_logo } from 'assets/icons';
import { CircularProgress } from '@mui/material';
import history from 'store/history';
import { hidePassword, showPassword } from 'assets/newIcons';

const AdminLogin = ({ adminLogin, isLoginRequesting }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPasswords, setshowPasswords] = useState(false);

  const togglePasswordType = () => {
    setshowPasswords(!showPasswords);
  };

  const showPassCondition = showPasswords ? hidePassword : showPassword;

  const handleSubmit = e => {
    e.preventDefault();
    const loginDetails = {
      email,
      password,
    };
    adminLogin(loginDetails);
  };
  const handleResetClick = e => {
    history.push('/admin/reset-password');
  };

  return (
    <>
      <div className={`${styles.wrapper}`}>
        <div
          style={{ width: '400px', marginTop: '50px' }}
          className={`${styles.formWrapper}`}
        >
          <img alt="" src={FSF_logo} className={`${styles.logo}`} />
          <div className={styles.childrenDiv}>
            <div className={styles.login}>
              <input
                type="text"
                placeholder="Email Address"
                className={styles.input}
                value={email}
                onChange={e => setEmail(e.target.value)}
              />
              <div className={styles.PasswordDiv}>
                <input
                  type={showPasswords ? 'text' : 'password'}
                  placeholder="Password"
                  className={styles.input}
                  value={password}
                  onChange={e => setPassword(e.target.value)}
                />
                <img
                  alt=""
                  src={showPassCondition}
                  onClick={togglePasswordType}
                  className={`${showPasswords ? styles.showIcon : styles.hideIcon}`}
                />
              </div>
              <div className={styles.buttonDiv}>
                <div className={styles.buttonStyle}>
                  <button
                    className={isLoginRequesting ? styles.disabled : styles.button}
                    onClick={handleSubmit}
                    disabled={isLoginRequesting}
                  >
                    {isLoginRequesting ? (
                      <CircularProgress
                        size={20}
                        style={{ color: '#FE5000', marginTop: '5px' }}
                      />
                    ) : (
                      'Sign In'
                    )}
                  </button>
                  <button className={styles.resetButton} onClick={handleResetClick}>
                    Reset Password
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminLogin;
